import { request } from "http";
import { apiClient } from "../apiClient";
import { CHUONG_TRINH_DAO_TAO_ENDPOINT } from "./chuongTrinhDaoTaoApi";
import { IChuongTrinhDaoTaoChiTietUpdateCongThucRequest } from "../../model/request/chuong-trinh-dao-tao/IChuongTrinhDaoTaoChiTietUpdateCongThucRequest";

const CHUONG_TRINH_DAO_TAO_CHI_TIET_ENDPOINT = "chuong-trinh-dao-tao-chi-tiet";
export const chuongTrinhDaoTaoChiTietApi = {
    SelectByChuongTrinhDaoTao: (id_dt: number) => apiClient.get(`${CHUONG_TRINH_DAO_TAO_ENDPOINT}/${id_dt}/chi-tiet`),
    UpdateCongThucs: (request: IChuongTrinhDaoTaoChiTietUpdateCongThucRequest) => apiClient.patch(`${CHUONG_TRINH_DAO_TAO_CHI_TIET_ENDPOINT}/cong-thucs`, request),
}